"use strict";

function shipmentsForSupplierOrder(record, invoices) {
  if (!record || !Array.isArray(invoices)) return [];
  var detailId = Number(record.orderDetailId);
  if (!Number.isInteger(detailId) || detailId <= 0) {
    try {
      var info = typeof record.info === 'string' ? JSON.parse(record.info) : record.info;
      detailId = Number(info && info.orderDetailId);
    } catch (error) {
      return [];
    }
  }
  if (!Number.isInteger(detailId) || detailId <= 0) return [];
  return invoices.filter(function (invoice) {
    return invoice && invoice.trackingNumber && Array.isArray(invoice.detailList) && invoice.detailList.some(function (line) {
      return line && Number(line.orderDetailId) === detailId;
    });
  }).map(function (invoice) {
    return {
      id: invoice.id,
      expressName: invoice.expressName,
      expressCode: invoice.expressCode,
      trackingNumber: invoice.trackingNumber
    };
  });
}
module.exports = {
  shipmentsForSupplierOrder: shipmentsForSupplierOrder
};